<template>
  <div v-if="hasSeller" class="subscribe-wrapper">
    <header class="main-header">
      <h1 class="trade-name" @click="scrollTop">{{ basicSeller.trade_name || basicSeller.name }}</h1>
      <h3 class="subtitle" v-if="choosePlan">{{ $t('subscribe.attributes.choose_your_plan') }}</h3>
      <h3 class="subtitle" v-if="checkout">{{ $t('subscribe.attributes.subscriber_information') }}</h3>
    </header>
    <main role="main">
      <plan v-if="choosePlan" @step="nextStep"></plan>
      <checkout v-if="checkout" @step="changeStep"></checkout>
    </main>
    <footer class="main-footer">
      <div v-if="basicSeller.id">
        <p>{{ basicSeller.trade_name || basicSeller.name }}</p>
        <p>{{ phone }}</p>
        <p>{{ basicSeller.email }}</p>
      </div>
    </footer>
  </div>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  import Plan from './Plan'
  import Checkout from './Checkout'
  import scroll from 'src/utils/scroll'
  import * as format from 'src/utils/form'
  import * as location from 'src/utils/location'

  export default {
    props: ['message'],
    components: { Plan, Checkout },
    data () {
      return {
        choosePlan: true,
        checkout: false,
        stickNav: false
      }
    },
    methods: {
      ...mapActions(['loadSellerData']),
      getUsernameFromUrl: function () {
        return location.getUsername()
      },
      changeStep () {
        this.choosePlan = true
        this.checkout = false
      },
      nextStep () {
        this.choosePlan = false
        this.checkout = true
      },
      handleScroll () {
        this.stickNav = window.scrollY > 26
      },
      scrollTop () {
        scroll.scrollToFlash()
      },
      changeClassTheme () {
        document.documentElement.classList.remove('ls-theme-green')
        document.documentElement.classList.add('ls-theme-cyanogen')
      },
      backToSignaturePlans () {
        this.checkout = false
        this.choosePlan = true
      }
    },
    created () {
      window.addEventListener('scroll', this.handleScroll)
    },
    computed: {
      ...mapGetters(['basicSeller']),

      phone () {
        if (this.basicSeller.contact) {
          return format.ddd(this.basicSeller.contact.area_code) + format.phone(this.basicSeller.contact.number)
        }
        return ''
      },
      hasSeller () {
        return this.basicSeller.id
      }
    },
    mounted () {
      this.changeClassTheme()
      this.loadSellerData(this.getUsernameFromUrl()).then(this.afterloadSellerData)
    }
  }
</script>
<style lang="scss">
  .subscribe-wrapper {
    min-height: 100%;
    display: flex;
    flex-direction: column;
    color: #717787;
    main {
      margin-top: 32px;
      flex: 1 0 auto;
    }
  }

  .main-header {
    line-height: 55px;
    padding: 15px;
    text-align: center;
    width: 100%;
    z-index: 999;
    .subtitle {
      color: #00a0c4;
    }
    @media screen and (max-width: 768px) {
      line-height: 26px;
      background: #393c46;
      color: #fff;
      display: block;
      transition: all 0.5s ease;
      z-index: 99;
      top: 0;
      opacity: 0.9;
      .trade-name {
        cursor: pointer;
      }
      .subtitle {
        color: #fff!important;
        font-size: 22px;
        margin-bottom: 0;
      }
    }
  }

  .ls-alert-danger ~ header {
    padding-top: 90px;
  }

  .subtitle {
    font-size: 30px;
    font-weight: 100;
    text-align: center;
    -webkit-font-smoothing: antialiased;
  }

  .ls-label-text {
    color: #6e768d;
    font-weight: bold;
    font-size: 12px;
  }

  .box-group {
    align-items: center;
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
    justify-content: center;
    .ls-box {
      &:hover {
        transform: scale(1.08);
        box-shadow: 0 4px 8px -2px rgba(0, 0, 0, 0.2);
        @media screen and (max-width: 768px) {
          transform: none;
        }
      }
    }
    .main-footer, &:after {
      height: 142px;
    }
  }

  .main-footer {
    position: relative;
    z-index: 0;
    overflow: hidden;
    text-align: center;
    padding: 20px 0;
    width: 100%;
    height: 128px;
    @media screen and (max-width: 768px) {
      height: 155px;
    }
  }

  .ls-error {
    input {
      background: rgba(255, 0, 0, 0.05);
    }
  }

  $default: #e2e6e7;
  $color-act: #2fcc71;
  $custom-color: #f66466;

  .btn {
    border: none;
    background: $default;
    border-radius: 4px;
    color: #909ea1;
    cursor: pointer;
    font-size: 13px;
    padding: 14px;
    transition: all 0.2s;
    &:hover {
      background: darken($default, 5%);
    }
    &.btn-lg {
      font-size: 16px;
      padding: 14px;
    }
    &.btn-fixed-bottom-xs {
      @media screen and (max-width: 768px) {
        &.next {
          right: 0;
          width: 50%;
          span {
            float: right;
            position: absolute;
            right: 15px;
          }
        }
        &.prev {
          left: 0;
          width: 50%;
          span {
            float: left;
            position: absolute;
            left: 15px;
          }
        }
        &.once {
          left: 0;
          width: 100%;
        }
        display: block;
        position: fixed;
        bottom: 0;
        z-index: 999;
        border-radius: 0;
        padding: 18px;
      }
    }
  }

  .btn-act {
    border: none;
    background: $color-act;
    color: #fff;
    &:hover {
      background: lighten($color-act, 10%);
    }
    &:disabled {
      background-color: lighten($color-act, 25%);
      cursor: not-allowed;
      &:hover {
        background-color: lighten($color-act, 25%);
      }
    }
  }

  .btn-custom {
    background-color: $custom-color;
    border: none;
    color: #fff;
    &:hover {
      background-color: lighten($custom-color, 10%)!important;
    }
    &:disabled {
      background-color: lighten($custom-color, 25%)!important;
      cursor: not-allowed;
      &:hover {
        background-color: lighten($custom-color, 25%)!important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Main.vue?1fbb9436